import { IoIosArrowDown } from 'react-icons/io';
import SlideDown from 'react-slidedown';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface HowToProps {
  $active: boolean;
}
export const HowTo: any = styled.div`
  padding: 16px;
  box-shadow: 0 2px 16px 0 rgb(0 0 0 / 10%);
  border-radius: 8px;
  background-color: ${ColorPalette.HEX.White};
  margin: 24px 0;
`;

HowTo.Header = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

HowTo.Title = styled.h1`
  padding: 0 30px 0 0;
  color: ${ColorPalette.HEX.OuterSpace};
  font-weight: 600;
  font-size: 14px;
  line-height: 1em;
`;

HowTo.Icon = styled(IoIosArrowDown)`
  font-size: 20px;
  padding: 0 2px;
  box-sizing: content-box;
  color: ${({ theme }) => theme.flightDetails.card.arrowDown} !important;

  &.active {
    transform: rotate(-180deg);
  }
`;

HowTo.Body = styled.div<HowToProps>`
  h3 {
    padding: 12px 0 0;
    border-top: 0.5 solid ${ColorPalette.HEX.Platinum2};
    font-size: 14px;
    margin: 8px 0;
    color: ${ColorPalette.HEX.OuterSpace};

    &:first-child {
      padding-top: 8px;
      border-top: none;
    }
  }
  p {
    font-size: 12px;
    color: ${ColorPalette.HEX.DimGray2};
    margin: 8px 0;
    &:last-child {
      margin-bottom: 24px;
    }
  }
`;

export const HowtoSlideDown = styled(SlideDown)`
  transition-duration: 0.2s;
  width: 100%;
`;
